<template>
    <div></div>
</template>

<script>
    import axios from 'axios';
    import UserSession from '@/service/UserSession';

    export default {
        async mounted() {
            const userSession = new UserSession(localStorage);
            const q = this.$route.query;

            if (!q.client_id) {
                this.$router.replace({ name: 'Home' });
                return;
            }

            try {
                const response = await axios.post('/oauth2/authorize', {
                    response_type: q.response_type,
                    client_id: q.client_id,
                    redirect_uri: q.redirect_uri,
                    state: q.state,
                    scope: q.scope,
                    code_challenge: q.code_challenge,
                    code_challenge_method: q.code_challenge_method,
                }, {
                    headers: { Authorization: `Bearer ${userSession.accessToken}` },
                });
                window.location = response.data.redirect_url;
            } catch (err) {
                // Backend returns 4xx only for non-redirectable errors
                // (unknown client / disallowed redirect_uri). Per spec we must NOT
                // auto-redirect in that case; bounce to Home so a misconfigured
                // client doesn't silently bounce the user away.
                this.$router.replace({ name: 'Home', query: { continue: window.location.href } });
            }
        }
    }
</script>
